import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage';

// Your Firebase configuration (replace with your actual Firebase config)
const firebaseConfig = {
    apiKey: "AIzaSyCwWgigzGeq6szeWdYUCyObCvHGUo9kQA",
    authDomain: "augmentedoccasionsqr.firebaseapp.com",
    projectId: "augmentedoccasionsqr",
    storageBucket: "augmentedoccasionsqr.appspot.com",
    messagingSenderId: "352751391451",
    appId: "1:352751391451:web:911d0d3a92dd1238eb32fe",
    measurementId: "G-R22NHHB3PP"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);

export { db, storage };
